// in addUploadFeature.js
/**
 * Convert a `File` object returned by the upload input into a base 64 string.
 * That's not the most optimized way to store images in production, but it's
 * enough to illustrate the idea of data provider decoration.
 */
const convertFileToBase64 = file => new Promise((resolve, reject) => {
    
    if(file && file.rawFile){
        //console.log('convertFileToBase64 - encoding');
        const reader = new FileReader();
        reader.readAsDataURL(file.rawFile);

        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    } else  {
        //console.log('convertFileToBase64 - pass');
        resolve(null);
    }
});

/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `picture` sent property, with `src` and `title` attributes.
 */
const addUploadFeature = (requestHandler) => (type, resource, params) => {
    // console.log('-----------------requestHandler-----------------');
    // console.log(requestHandler);
    // console.log(type);
    // console.log(resource);
    // console.log(params);

    /**
     * CREATE시
     "problem": [
      {
        "answer": "1",
        "pdf": {
          "src": "blob:http://localhost:3000/e881b36a-72f8-47b6-8f7c-5da04686107e",
          "title": "question.pdf",
          "rawFile": {
            "preview": "blob:http://localhost:3000/e881b36a-72f8-47b6-8f7c-5da04686107e"
          }
        }
      }
    ]
     * UPDATE시
     "problem": [
      {
        "answer": "1",
        "pdf": {
          "src": "http://image.symplai.co.kr/pdf/1563284656157/_0.pdf",
          "title": "_1.pdf"
        }
      }
    ],
     */
    if ( type == 'CREATE' || type === 'UPDATE' ) {
        //답안 업로드 pdf_bunch 모두
        params.data.current_url = window.location.href;
        
        var p1;
        if (params.data.pdf_bunch && params.data.pdf_bunch.length) 
        {
            /*
                pdf_bunch : [{rawFile:... , pdf_bunch:..., title:...}]
            */
            console.log('upload bunch');
            //파일 명 법칙으로 한꺼번에 attach된 파일
            var pdf_bunch = params.data.pdf_bunch;
            p1 = Promise.all(pdf_bunch.map( o => {
                return convertFileToBase64(o);
            }))
            .then(base64Pictures => base64Pictures.map((base64pdf, index) => {
                var r = {...pdf_bunch[index]};
                if(base64pdf){
                    r.rawFile = base64pdf;
                    console.log('get pdf_bunch' );
                } else {
                    console.log('get no pdf_bunch' );
                }
                console.log('------------pdf_bunch--------------');
                console.log(JSON.stringify(r));
                return r;
            }));
        }

        //답안 업로드 pdf 개별
        var p2;
        if (params.data.problem && params.data.problem.length) 
        {
            console.log('upload individual');
            var problem = params.data.problem;
            //개별적으로 attach된 파일
            p2 = Promise.all(problem.map( o => {
                return convertFileToBase64(o.pdf);
            }))
            .then(base64Problems => base64Problems.map((problem64, index) => {
                var r = {...problem[index]};
                
                if(problem64){
                    //console.log('get problem64' );
                    r.pdf.rawFile = problem64;
                } else {
                    //console.log('get no problem64' );
                }
                //console.log(JSON.stringify(r));

                return r;
            }));
        }
        
        //답안 엑셀 or 업로드 엑셀
        var p3;
        if (params.data.pdf_excel) 
        {
            console.log('upload excel');
            var pdf_excel = params.data.pdf_excel;
            p3 = convertFileToBase64(pdf_excel);
        }

        //표지 이미지
        var p4;
        if (params.data.img) 
        {
            console.log('upload img');
            var img = params.data.img;
            p4 = convertFileToBase64(img);
        }

        //표지 이미지
        var p5;
        if (params.data.wav) 
        {
            console.log('upload wav');
            var wav = params.data.wav;
            p5 = convertFileToBase64(wav);
        }

        var p6;
        if (params.data.android_notification_icon) 
        {
            console.log('upload android_notification_icon');
            var android_notification_icon = params.data.android_notification_icon;
            p6 = convertFileToBase64(android_notification_icon);
        }

        return Promise.all([p1, p2, p3, p4, p5, p6]).then(results => {
            var pdf_bunch_result = results[0];
            var problem_result = results[1];
            var excel_result = results[2];
            var img_result = results[3];
            var wav_result = results[4];
            var android_notification_icon = results[5];
            var r = {
                ...params
            };

            console.log('--pdf_bunch_result--');
            console.log(pdf_bunch_result);
            
            if(pdf_bunch_result != null) {
                r.data.pdf_bunch = pdf_bunch_result;
            }

            if(problem_result != null) {
                r.data.problem = problem_result;
            }

            if(excel_result != null){
                r.data.excel = excel_result;
            }

            if(img_result != null){
                r.data.imgRaw = img_result;
            }

            if(wav_result != null){
                r.data.wavRaw = wav_result;
            }

            if(android_notification_icon != null){
                r.data.android_notification_icon_raw = android_notification_icon;
            }

            return requestHandler[typeToType(type)](resource, r);
        });
    } else{
        // return new Promise((resolve, reject) => {
            
        //     return fetch(...params)
        //         .then(res => res.json())
        //         .then(json => {
        //             if (json.error) {
        //                 // The notification will show what's in { error: "message" }
        //                 reject(new Error(json.error.message));
        //                 return;
        //             }
    
        //             resolve(json);
        //         });
        // });
        return requestHandler[typeToType(type)](resource, params);
    } 
        
};

function typeToType(type) {
    if(type == 'GET_LIST')
        return 'getList';
    if(type == 'GET_ONE')
        return 'getOne';
    if(type == 'GET_MANY')
        return 'getMany';
    if(type == 'GET_MANY_REFERENCE')
        return 'getManyReference';
    if(type == 'UPDATE')
        return 'update';
    if(type == 'UPDATE_MANY')
        return 'updateMany';
    if(type == 'CREATE')
        return 'create';
    if(type == 'DELETE')
        return 'delete';
    if(type == 'DELETE_MANY')
        return 'deleteMany';
    return type;
}

export default addUploadFeature;